import moment from "moment";
import {
  convertStraight,
  convertThenFormat,
  currentDateOfTheMonth,
} from "../../common-data/Converts";

export const agentDateWiseTbColumns = [
  {
    dataField: "date",
    text: <p className="table__header">Date</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data minWidth90 table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.date ? moment(row.date).format("DD-MM-YYYY") : "-"}
        </p>
      );
    },
  },
  {
    dataField: "new_subscription",
    text: <p className="table__header">New Recurring Subscription</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {`₹${convertThenFormat(row?.new_subscription || 0)}`}
        </p>
      );
    },
  },
  {
    dataField: "non_recurring_renewal",
    text: <p className="table__header">renewal</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {`₹${convertThenFormat(row?.non_recurring_renewal || 0)}`}
        </p>
      );
    },
  },
  {
    dataField: "non_recurring_unpaid",
    text: <p className="table__header">unpaid</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {/* {row?.unpaid ? `₹${row?.unpaid}` : "NA"} */}
          {`₹${convertThenFormat(row?.non_recurring_unpaid || 0)}`}
        </p>
      );
    },
  },
  {
    dataField: "non_recurring_other_sources",
    text: <p className="table__header">non recurring other sources</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {`₹${convertThenFormat(row?.non_recurring_other_sources || 0)}`}
        </p>
      );
    },
  },
  {
    dataField: "membership",
    text: <p className="table__header">New non recurring</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {`₹${convertThenFormat(row?.membership || 0)}`}
        </p>
      );
    },
  },
  {
    dataField: "addon_pt",
    text: <p className="table__header">PT</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {`₹${convertThenFormat(row?.addon_pt || 0)}`}
        </p>
      );
    },
  },
  {
    dataField: "total",
    text: <p className="table__header">Total</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {`₹${convertThenFormat(row?.total || 0)}`}
        </p>
      );
    },
  },
];

export const agentSopTbColumns = [
  {
    dataField: "gym_name",
    text: <p className="table__header">gym name</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text link"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.gym_name || "NA"}
        </p>
      );
    },
  },
  {
    dataField: "this_month_total_unpaid",
    text: <p className="table__header">this month total unpaid</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.this_month_total_unpaid ? row?.this_month_total_unpaid : 0}
        </p>
      );
    },
  },
  {
    dataField: "this_month_unpaid_added_to_lead",
    text: <p className="table__header">this month unpaid added to lead</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.this_month_unpaid_added_to_lead
            ? row?.this_month_unpaid_added_to_lead
            : 0}
        </p>
      );
    },
  },
  {
    dataField: "this_month_unpaid_today_followup",
    text: (
      <p className="table__header">
        this month unpaid today follow up (
        {convertStraight(currentDateOfTheMonth)})
      </p>
    ),
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.this_month_unpaid_today_followup
            ? row?.this_month_unpaid_today_followup
            : 0}
        </p>
      );
    },
  },
  {
    dataField: "sixty_days_total_unpaid",
    text: <p className="table__header">sixty days total unpaid</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.sixty_days_total_unpaid ? row?.sixty_days_total_unpaid : 0}
        </p>
      );
    },
  },
  {
    dataField: "sixty_days_unpaid_added_to_lead",
    text: <p className="table__header">sixty days unpaid added to lead</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.sixty_days_unpaid_added_to_lead
            ? row?.sixty_days_unpaid_added_to_lead
            : 0}
        </p>
      );
    },
  },
  {
    dataField: "sixty_days_unpaid_not_added_to_lead",
    text: <p className="table__header">sixty days unpaid not added to lead</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.sixty_days_unpaid_not_added_to_lead
            ? row?.sixty_days_unpaid_not_added_to_lead
            : 0}
        </p>
      );
    },
  },
  {
    dataField: "sixty_days_unpaid_today_followup",
    text: (
      <p className="table__header">
        sixty days unpaid today follow up (
        {convertStraight(currentDateOfTheMonth)})
      </p>
    ),
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.sixty_days_unpaid_today_followup
            ? row?.sixty_days_unpaid_today_followup
            : 0}
        </p>
      );
    },
  },
  {
    dataField: "this_month_missed_interested_followup",
    text: (
      <p className="table__header">this month missed interested follow up</p>
    ),
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.this_month_missed_interested_followup
            ? row?.this_month_missed_interested_followup
            : 0}
        </p>
      );
    },
  },
  {
    dataField: "today_followup_added",
    text: <p className="table__header">today follow up added</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.today_followup_added ? row?.today_followup_added : 0}
        </p>
      );
    },
  },
  {
    dataField: "advancerenew_this_month",
    text: <p className="table__header">advance renewel this month</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.advancerenew_this_month ? row?.advancerenew_this_month : 0}
        </p>
      );
    },
  },
  {
    dataField: "advancerenew_today_followup",
    text: (
      <p className="table__header">
        advance renewel today follow up (
        {convertStraight(currentDateOfTheMonth)})
      </p>
    ),
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.advancerenew_today_followup
            ? row?.advancerenew_today_followup
            : 0}
        </p>
      );
    },
  },
  {
    dataField: "expt_today",
    text: (
      <p className="table__header">
        expiry today ({convertStraight(currentDateOfTheMonth)})
      </p>
    ),
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.expt_today ? row?.expt_today : 0}
        </p>
      );
    },
  },
  {
    dataField: "expt_today_followup",
    text: (
      <p className="table__header">
        expiry today follow up ({convertStraight(currentDateOfTheMonth)})
      </p>
    ),
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.expt_today_followup ? row?.expt_today_followup : 0}
        </p>
      );
    },
  },
  {
    dataField: "rawlead_assigned_today",
    text: (
      <p className="table__header">
        raw lead assigned today ({convertStraight(currentDateOfTheMonth)})
      </p>
    ),
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.rawlead_assigned_today ? row?.rawlead_assigned_today : 0}
        </p>
      );
    },
  },
  {
    dataField: "rawlead_assigned_today_followup",
    text: (
      <p className="table__header">
        raw lead assigned today follow up (
        {convertStraight(currentDateOfTheMonth)})
      </p>
    ),
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.rawlead_assigned_today_followup
            ? row?.rawlead_assigned_today_followup
            : 0}
        </p>
      );
    },
  },
  {
    dataField: "total_receptionist",
    text: <p className="table__header">total receptionist</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.total_receptionist ? row?.total_receptionist : 0}
        </p>
      );
    },
  },
  {
    dataField: "sales_target_today",
    text: (
      <p className="table__header">
        sales target today ({convertStraight(currentDateOfTheMonth)})
      </p>
    ),
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.sales_target_today
            ? `₹${convertThenFormat(row?.sales_target_today)}`
            : 0}
        </p>
      );
    },
  },
  {
    dataField: "sales_completed_today",
    text: (
      <p className="table__header">
        sales completed today ({convertStraight(currentDateOfTheMonth)})
      </p>
    ),
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.sales_completed_today
            ? `₹${convertThenFormat(row?.sales_completed_today)}`
            : 0}
        </p>
      );
    },
  },
];

export const agentwiseTbColumns = [
  {
    dataField: "account_type",
    text: <p className="table__header">Agent Details</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data minWidth150 table__Text"
          style={{
            textWrap: "wrap",
            lineHeight: "21px",
          }}
        >
          <b
            style={{
              color:
                row?.account_type === "trainer"
                  ? "#006BFF"
                  : row?.account_type === "receptionist"
                  ? "#0A4CCC"
                  : "#000",
            }}
          >
            ({row?.account_type || "NA"})
          </b>{" "}
          <br />
          {row?.sub_added_by_name || ""} <br />
          <span
            style={{
              textTransform: "lowercase",
              textDecoration: "underline",
            }}
          >
            {row?.sub_added_by_mobile || ""} <br />
            {row?.sub_added_by_email || ""}
          </span>
        </p>
      );
    },
  },
  {
    dataField: "gym_name",
    text: <p className="table__header">Gym Name</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.gym_name || "NA"}
        </p>
      );
    },
  },
  {
    dataField: "new_subscription",
    text: <p className="table__header">New Recurring Subscription</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {`₹${convertThenFormat(row?.new_subscription || 0)}`} <br />
        </p>
      );
    },
  },
  {
    dataField: "non_recurring_renewal",
    text: <p className="table__header">renewal</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {`₹${convertThenFormat(row?.non_recurring_renewal || 0)}`}
        </p>
      );
    },
  },
  {
    dataField: "non_recurring_unpaid",
    text: <p className="table__header">unpaid</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {/* {row?.unpaid ? `₹${row?.unpaid}` : "NA"} */}
          {`₹${convertThenFormat(row?.non_recurring_unpaid || 0)}`}
        </p>
      );
    },
  },
  {
    dataField: "non_recurring_other_sources",
    text: <p className="table__header">non recurring other sources</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.non_recurring_other_sources
            ? `₹${convertThenFormat(row?.non_recurring_other_sources)}`
            : "₹0"}
        </p>
      );
    },
  },
  {
    dataField: "membership",
    text: <p className="table__header">New non recurring</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.membership ? `₹${convertThenFormat(row?.membership)}` : "₹0"}
        </p>
      );
    },
  },
  {
    dataField: "addon_pt",
    text: <p className="table__header">PT</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.addon_pt ? `₹${convertThenFormat(row?.addon_pt)}` : "₹0"}
        </p>
      );
    },
  },
  {
    dataField: "Total",
    text: <p className="table__header">total</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text"
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.total ? `₹${convertThenFormat(row?.total)}` : "₹0"}
        </p>
      );
    },
  },
  // {
  //   dataField: "Total",
  //   text: <p className="table__header">total</p>,
  //   formatter: (cell, row) => {
  //     return (
  //       <p
  //         className="tb-data table__Text"
  //         style={{
  //           textWrap: "wrap",
  //         }}
  //       >
  //         {row?.total ? `₹${convertThenFormat(row?.total)}` : "NA"}
  //       </p>
  //     );
  //   },
  // },
];
